import { z } from "zod";
import { EventWithCustomField, PaginatedUserEventType } from "@ac-expo/api-types";

type DuplicableEvent = EventWithCustomField<
  Pick<PaginatedUserEventType, "id" | "name" | "type" | "address" | "organiserEmail" | "organiserPhone" | "isPaidEntry" | "isIndoor" | "isOutdoor">
>;
import { defaultPlaceValues, PlaceForm } from "./event-place.schema";
import { defaultAddressValues } from "../utils/address.schema";
import {
  createEventSchema,
  defaultCreateEventValues,
} from "./create-event.schema";

export const duplicateEventSchema = createEventSchema.extend({
  id: z.string(),
  relatedDataToDuplicate: z.object({
    ticketing: z.boolean().optional(),
    features: z.boolean().optional(),
  }),
});

export const defaultDuplicateEventValues = {
  ...defaultCreateEventValues,
} satisfies Partial<DuplicateEventForm>;

export const getDuplicateEventValuesFromEvent = (
  event: DuplicableEvent
) =>
  ({
    id: event.id,
    name: event.name,
    type: event.type,
    place: {
      name: event.address?.name ?? defaultPlaceValues.name,
      address: event.address
        ? {
            ...event.address,
            lat: event.address.lat ? Number(event.address.lat) : null,
            long: event.address.long ? Number(event.address.long) : null,
          }
        : defaultAddressValues,
      entrances: [],
    } satisfies Partial<PlaceForm>,
    dates: {
      from: new Date(event.startDate),
      to: new Date(event.endDate),
    },
    organiserEmail: event.organiserEmail ?? undefined,
    organiserPhone: event.organiserPhone ?? undefined,
    entry: event.isPaidEntry ? "paid" : "free",
    venue: {
      indoor: event.isIndoor,
      outdoor: event.isOutdoor,
    },
  }) satisfies Partial<DuplicateEventForm>;

export type DuplicateEventForm = z.infer<typeof duplicateEventSchema>;
